<template>
    <div class="sgPopover">
        <el-popover
            popper-class="sg-popover"
            :trigger="trigger"
            :placement="placement"
            :width="width"
            v-bind="$attrs"
            v-on="$listeners">
            <slot name="message">
                <p class="msg">{{msg}}</p>
            </slot>
            <slot name="footer">
                <div style="text-align: right; padding-top: 20px;">
                    <el-button v-if="showCancelBtn" type="text" size="medium" class="cancelBtn"  @click="cancelFn">{{cancelMsg}}</el-button>
                    <el-button v-if="showConfirmBtn" type="danger" class="confirmBtn" size="medium" @click="confirm">{{confirmMsg}}</el-button>
                </div>
            </slot>
            <div slot="reference">
                <slot name="refer">
                    <el-button type="text" :style="refStyle">{{ refMsg }}</el-button>
                </slot>
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        msg: String,
        showCancelBtn: {
            default: true,
            type: Boolean
        },
        showConfirmBtn: {
            default: true,
            type: Boolean
        },
        cancelMsg: {
            default: '取消',
            type: String
        },
        confirmMsg: {
            default: '确定',
            type: String
        },
        refMsg: {
            default: '移除',
            type: String
        },
        refStyle: {
            default: function() {
                return { color: '#EE5B5B' }
            },
            type: Object
        },
        cancelFn: {
            default: () => { document.body.click() },
            type: Function
        },
        confirmFn: Function,
        placement: {
            default: 'top-end',
            type: String
        },
        width: {
            type: String,
            default: '180'
        },
        trigger: {
            default: 'click',
            type: String
        }
    },

    created() {
        this.isLock = false
    },

    methods: {
        closePop() {
            document.body.click()
        },
        confirm() {
            if (this.isLock) {
                return
            }
            this.isLock = true
            document.body.click()
            if (this.confirmFn) {
                this.confirmFn()
            } else {
                this.$emit('confirmFn')
            }
            setTimeout(() => {
                this.isLock = false
            }, 600)
        }
    }
}
</script>

<style lang="scss">
    .sg-popover {
        padding: 10px !important;

        .msg {
            font-size: 14px;
            color: #666;
        }

        .confirmBtn {
            width: 64px;
            padding: 10px 0;
        }

        .cancelBtn {
            width: 52px;
            color: #ee5b5b;
        }

        .cancelBtn:hover {
            color: #f78989;
        }
    }
</style>
